import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "../src/Store/index";
import { PermissionProvider } from "./context/PermissionContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PermissionProvider>
      <ToastContainer />
      <App />
    </PermissionProvider>
  </Provider>
);

reportWebVitals();
